import React, { useState, useEffect } from "react";
import "./CurrencyTable.css";
import PriceTableHeader from "./PriceTableHeader";
import { getCurrencyData } from "../google-sheets";
import "flag-icons/css/flag-icons.min.css";

const DEFAULT_CURRENCIES = [
    { NgoaiTe: "Đô la Mỹ (USD)", TyGia: null, code: "us" },
    { NgoaiTe: "Euro (EUR)", TyGia: null, code: "eu" },
    { NgoaiTe: "Yên Nhật (JPY)", TyGia: null, code: "jp" },
    { NgoaiTe: "Nhân dân tệ (CNY)", TyGia: null, code: "cn" },
];

const CURRENCY_CODE_MAP = {
    "Đô la Mỹ (USD)": "us",
    "Euro (EUR)": "eu",
    "Yên Nhật (JPY)": "jp",
    "Nhân dân tệ (CNY)": "cn",
};

function CurrencyTable() {
    const [currentTime, setCurrentTime] = useState(new Date());
    const [currencyData, setCurrencyData] = useState(DEFAULT_CURRENCIES);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        getCurrencyData()
            .then((data) => {
                if (data && data.length > 0) {
                    const dataWithCodes = data.map(item => ({
                        ...item,
                        code: CURRENCY_CODE_MAP[item.NgoaiTe] || "unknown"
                    }));
                    setCurrencyData(dataWithCodes);
                }
            })
            .catch((e) => {
                console.error("Failed to fetch currency data:", e);
            });
    }, []);

    const formatTime = (date) => {
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const seconds = date.getSeconds().toString().padStart(2, "0");
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const dayOfWeek = ["Chủ nhật", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"][date.getDay()];
        return `${hours}:${minutes}:${seconds} --- ${dayOfWeek}, ${day}/${month}/${year}`;
    };

    const renderNumber = (value) => {
        try {
            if (!value && value !== 0) return "-";
            if (typeof value === "string" || value instanceof String) return value;
            return value.toLocaleString("en-US");
        } catch {
            return "-";
        }
    };

    return (
        <div className="currency-table-container mt-10">
             <PriceTableHeader title="BẢNG TỶ GIÁ NGOẠI TỆ" />

            <div className="currency-location-bar">
                <span className="currency-unit-text">ĐVT: VNĐ</span>
            </div>

            <div className="currency-grid">
                <div className="currency-grid-header">NGOẠI TỆ</div>
                <div className="currency-grid-header">TỶ GIÁ</div>

                {currencyData && currencyData.length > 0 ? (
                    currencyData.map((item, idx) => {
                        const rowClass = idx % 2 === 0 ? "currency-row-even" : "currency-row-odd";
                        return (
                            <React.Fragment key={idx}>
                                <div className={`currency-grid-item currency-name ${rowClass}`}>
                                    <span className={`fi fi-${item.code}`}></span>
                                    <b>{item.NgoaiTe}</b>
                                </div>
                                <div className={`currency-grid-item currency-rate ${rowClass}`}>
                                    {renderNumber(item.TyGia)}
                                </div>
                            </React.Fragment>
                        );
                    })
                ) : (
                    <div className="currency-loading-state">
                        Đang tải dữ liệu tỷ giá...
                    </div>
                )}
            </div>
        </div>
    );
}

export default CurrencyTable;
